"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CentredDiv = exports.CentredHeading = exports.StyledNoteAlert = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const streamline_icon_note_alert_svg_1 = __importDefault(require("@public/media/illustrations/streamline-icon-note-alert.svg"));
exports.StyledNoteAlert = (0, styled_components_1.default)(streamline_icon_note_alert_svg_1.default) `
	width: 200px;
	height: 200px;
`;
exports.CentredHeading = styled_components_1.default.h2 `
	text-align: center;
	color: ${props => props.theme.color.brand1};
`;
exports.CentredDiv = styled_components_1.default.div `
	text-align: center;
	margin: 1rem;
`;
